export default "__VITE_ASSET__pykOzACL__"